export const EVENTLOG_REQUEST = 'EVENTLOG_REQUEST'
export const EVENTLOG_SUCCESS = 'EVENTLOG_SUCCESS'
export const EVENTLOG_ERROR = 'EVENTLOG_ERROR'
